import { ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SearchResultService {
    contextReceivedSource = new Subject<any>();
    contextReceived$ = this.contextReceivedSource.asObservable();

    receiveContext(componentFactoryResolver: ComponentFactoryResolver, injector: Injector) {
        this.contextReceivedSource.next({ resolver: componentFactoryResolver, injector: injector });
    }
}
